import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Booking, BookingsQueryResponse, Review, Summary, Timesheet} from './_models'
import {ProfilesQueryResponse} from '../../../../accounts/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const BOOKING_URL = `${API_URL}/booking`
const STAFF_URL = `${API_URL}/user/staff`

const getBookings = (query: string): Promise<BookingsQueryResponse> => {
  return axios.get(`${BOOKING_URL}?${query}`)
}
const getSummary = (query: string): Promise<Summary> => {
  return axios.get(`${BOOKING_URL}/summary?${query}`)
}

const getBookingById = (id: ID): Promise<Booking | undefined> => {
  return axios.get(`${BOOKING_URL}/${id}`)
}
const getOpenBookingById = (id: ID): Promise<Booking | undefined> => {
  return axios.get(`${BOOKING_URL}/get-one/${id}`)
}
const createBooking = (booking: Booking): Promise<Booking | undefined> => {
  return axios.post(BOOKING_URL, booking)
}
const createReview = (review: Review): Promise<Review | undefined> => {
  return axios.post(API_URL + '/review', review)
}
const createBookings = (booking: Booking): Promise<Booking | undefined> => {
  return axios.post(BOOKING_URL + '/multiple', booking)
}

const updateBooking = (booking: Booking): Promise<Booking | undefined> => {
  return axios.patch(`${BOOKING_URL}`, booking)
}

const deleteBooking = (bookingId: ID): Promise<void> => {
  return axios.delete(`${BOOKING_URL}/${bookingId}`)
}

const deleteSelectedBookings = async (bookingIds: Array<ID>): Promise<void> => {
  const requests = bookingIds.map((id) => axios.delete(`${BOOKING_URL}/${id}`))
  await axios.all(requests)
}
const getStaffs = (query: string): Promise<ProfilesQueryResponse> => {
  return axios.get(`${STAFF_URL}?${query}`)
}

const createTimesheet = (timesheet: any): Promise<Timesheet | undefined> => {
  return axios.post(BOOKING_URL + '/timesheet', timesheet)
}
const updateTimesheet = (timesheet: Timesheet): Promise<Timesheet | undefined> => {
  return axios.patch(`${BOOKING_URL}/timesheet`, timesheet)
}
export {
  getBookings,
  deleteBooking,
  deleteSelectedBookings,
  getBookingById,
  getOpenBookingById,
  createBooking,
  createBookings,
  updateBooking,
  createTimesheet,
  updateTimesheet,
  getStaffs,
  getSummary,
  createReview,
}
